import { NativeStackHeaderProps } from '@react-navigation/native-stack'
import debounce from 'debounce'
import { Stack } from 'expo-router'
import { useState } from 'react'
import { View } from 'react-native'
import { StyleSheet } from 'react-native-unistyles'

import SearchHeader from '@/components/search/SearchHeader'
import SearchResults from '@/components/search/SearchResults'

const Header = (
  props: NativeStackHeaderProps,
  onChangeText: (text: string) => void
) => <SearchHeader {...props} onChangeText={onChangeText} />

const Search = () => {
  const [searchInput, setSearchInput] = useState('')
  const debouncedSetSearchInput = debounce(setSearchInput, 200)

  if (!searchInput && searchInput !== '') {
    debouncedSetSearchInput('')
    return
  }

  const onChangeText = (text: string) => {
    debouncedSetSearchInput(text)
  }

  return (
    <>
      <Stack.Screen
        options={{
          title: 'Search',
          headerBackVisible: false,
          animation: 'slide_from_bottom',
          animationDuration: 200,
          header: (props) => Header(props, onChangeText),
        }}
      />

      {/* We can't wrap this with our page component, because the nested scrollview will break FlashList's paging computations */}
      <View nativeID="search-results" style={styles.container}>
        <SearchResults searchInput={searchInput} />
      </View>
    </>
  )
}

const styles = StyleSheet.create((theme) => ({
  container: {
    flex: 1,
    paddingHorizontal: theme.tokens.spacing[4],
  },
}))

export default Search
